'use strict'

import axios from 'axios'

const {
  VUE_APP_ENVIRONMENT,
  VUE_APP_FILESIGN_URL
} = process.env

export default async ({ userId, jwt }) => {
  return axios({
    method: 'delete',
    url: `${VUE_APP_FILESIGN_URL}/2ef1fbbbd4c2d1f599ff65358aa35ffd/${userId}`,
    headers: {
      Authorization: jwt,
      'X-Environment': VUE_APP_ENVIRONMENT
    },
    timeout: 8000
  })
}
